import posed from 'react-pose';

export const AnimatedCard = posed.div({
  hidden: {
    opacity: 0,
    scale: 0.6,
    transition: {
      ease: 'easeIn',
      duration: 150,
    },
  },
  visible: {
    opacity: 1,
    scale: 1,
  },
});
